


export const siteConfig = {
  name: "Tblondi",
  description: "Collaboration Marketplace platform for Creators and Brands.",
  theme: "blue",
  layout: "horizontal",
  // semi-box, horizontal, vertical
  hideSideBar: false,
  sidebarType: "classic",
  // popover, classic, module
  sidebarColor: null,
  navbarType: "sticky",
  // sticky, floating, static
  footerType: "sticky",
  // sticky,  static, hidden
  sidebarBg: "none",
  radius: 1.0,
};
